import moment from 'moment-timezone'

export const dateNow = (domain?: any) => (domain?.timezone ? moment.tz(moment(), domain.timezone) : moment())
